// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__G0Kxh","skillsData":"Skills_skillsData__KPL+H"};